// Collection quick add to cart
let quickAddToCarts = document.querySelectorAll('.quick-atc');
quickAddToCarts.forEach(function (button) {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    let data = {
      'id': parseInt(button.getAttribute('data-id')),
      'quantity': 1
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }).then(function () {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: 43239128793303,
          quantity: 1
        }
      }));
    }).catch(error => {
      console.error('Error:', error);
    });
  });
});

/* CART */

document.addEventListener('cart:refresh', bindCartEvents);
document.addEventListener('product:added', bindCartEvents);
function bindCartEvents() {
  setTimeout(function () {
    // We need a setTimeout to wait for the cart to re-render

    // Cart items info fields

    let addInfoLinks = document.querySelectorAll('.CartItem__AddInfo');
    let infoFields = document.querySelectorAll('.CartItem__InfoField');
    addInfoLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        link.style.display = 'none';
        link.parentNode.querySelector('.CartItem__InfoField').style.display = 'block';
      });
    });

    // Add a property to the line item
    infoFields.forEach(function (field) {
      field.addEventListener('change', function () {
        let data = {
          'id': field.getAttribute('data-line-key'),
          'quantity': parseInt(field.getAttribute('data-line-quantity')),
          'properties': {
            'commentaire': field.value
          }
        };
        if (field.value == "") {
          data.properties['commentaire'] = null;
        }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        }).then(function () {
          console.log("Property added");
        }).catch(error => {
          console.error('Error:', error);
        });
      });
    });
  }, 500);
}

/* PAGES SECTIONS */

$(document).ready(function () {
  /* Slider for collabs in "our collections" page */
  $('.slider-with-text__slider-container').flickity({
    // options
    cellAlign: 'center',
    contain: true,
    groupCells: '100%'
  });

  /* Slider for our collections page */
  $('.page-slider__container').flickity({
    // options
    groupCells: 1,
    contain: true,
    selectedAttraction: 0.15,
    friction: 0.8
  });

  /* Job offers dropdown */
  $('.job-offer-dropdown__offers-title').click(function () {
    $(this).closest('.job-offer-dropdown__offers-container').find('.job-offer-dropdown__items').slideToggle(400);
    $(this).closest('.job-offer-dropdown__offers-container').find('.job-offer-dropdown__arrow').toggleClass('active');
  });
});

/* SHOW PASSWORD LOGIN */

const eye = document.querySelector('.Form__ItemShowPassword');
const password = document.querySelector('.Form__Input.login-password');
eye.addEventListener('click', function () {
  if (password.type == 'password') {
    password.type = 'text';
  } else if (password.type == 'text') {
    password.type = 'password';
  }
});